export const ENLIGHTENED_STARTING_COINS_BONUS = 5;
export const ENLIGHTENED_COINS_TO_WIN_POINTS_CONVERSION = 1;
